import type { ReactNode } from "react";

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./tooltip";

export interface WithTooltipProps {
  /** Tooltip text. Use the consumer element's `aria-label` value here too — keep them in sync. */
  label: string;
  /** Tooltip placement. Default "bottom". */
  side?: "top" | "bottom" | "left" | "right";
  children: ReactNode;
}

/**
 * SIM-1617: tooltip wrapper for non-button triggers — reach for `<TooltipButton>` first and use
 * this only when the trigger is not a button. The consumer must set its own `aria-label` to match
 * the tooltip text; this cannot enforce a11y for arbitrary children, which is exactly what
 * `TooltipButton` fuses. A local `<TooltipProvider>` makes it work standalone in test renders.
 */
export function WithTooltip({ label, side = "bottom", children }: WithTooltipProps) {
  return (
    <TooltipProvider delayDuration={700}>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent side={side}>{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
